<template>
  <div class="all-courses-page">
    <Navbar />
    <div class="banner-area">
      <div class="banner-container">
        <div class="banner-content">
          <h2 class="banner-title">隱私權政策及會員服務條款</h2>
        </div>
      </div>
    </div>

    <!-- 主要內容區塊錨點 (位於 Banner 之下) -->
    <div id="main-content" tabindex="-1" class="main-content-anchor">
      <a
        id="accesskey-c"
        href="#accesskey-c"
        accesskey="C"
        class="accesskey-brick sr-only-focusable"
        title="主要內容區塊，快捷鍵：Alt+C"
        aria-label="主要內容區塊"
      >:::</a>
    </div>

    <!-- 導航快捷錨點列 -->
    <div class="quick-nav-wrapper">
      <div class="quick-nav-container">
        <button class="nav-chip" @click="scrollToSection('privacy-policy')">第一部分 隱私權政策</button>
        <button class="nav-chip" @click="scrollToSection('terms-of-service')">第二部分 會員服務條款</button>
        <button class="nav-chip" @click="scrollToSection('common-provisions')">第三部分 共同事項</button>
        <button class="nav-chip" @click="scrollToSection('contact-us')">聯絡我們</button>
      </div>
    </div>

    <div class="content">
      <div class="privacy-content-wrapper">
        <PrivacyAndTermsDocument />
      </div>
    </div>

    <FooterSection />
  </div>
</template>

<script setup>
import { useLayoutStore } from "@/stores/layout";
import Navbar from "@/components/Navbar.vue";
import FooterSection from "@/components/FooterSection.vue";
import PrivacyAndTermsDocument from "@/components/PrivacyAndTermsDocument.vue";

const layoutStore = useLayoutStore();

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};
</script>

<style scoped lang="scss">
.all-courses-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fcfcfc;
}

.banner-area {
  background-color: var(--color-primary-active, #022964);
  width: 100%;
  margin-top: v-bind("layoutStore.pageMarginTop");

  @media (max-width: 768px) {
    margin-top: v-bind('layoutStore.showAnnouncementBanner ? "160px" : "55px"');
  }
}

.banner-container {
  max-width: 1200px;
  margin: 0 auto;
  height: 180px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;
}

.banner-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
}

.banner-title {
  font-size: 38px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  letter-spacing: 0.5px;
}

.quick-nav-wrapper {
  background-color: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 70px;
  z-index: 10;
}

.quick-nav-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 10px 20px;
  display: flex;
  gap: 12px;
  overflow-x: auto;
  white-space: nowrap;
}

.nav-chip {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  padding: 6px 14px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #e2e8f0;
    color: #0f172a;
    border-color: #cbd5e1;
  }
}

.content {
  flex: 1;
  padding: 40px 20px;
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.privacy-content-wrapper {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 40px 48px;
}

@media (max-width: 768px) {
  .banner-container {
    height: 120px;
    padding: 0 20px;
  }

  .banner-title {
    font-size: 24px;
  }

  .content {
    padding: 20px 12px;
  }

  .privacy-content-wrapper {
    padding: 24px 16px;
  }

  .quick-nav-wrapper {
    top: 55px;
  }
}
</style>